import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Form
import { RenderDropdown } from '../../forms';

// Selectors
import { makeSelectEntityTypeValue } from '../../services/entityTypes/selectors';
import { selectOptions } from './selectors';

interface Props {
    options: {
        id: number,
        name: string
    }[];
    schemaId?: number;
    entityTypeId?: number;
    disabled?: boolean;
    multiple?: boolean;
    name: string;
    validate?: Function | Function[];
    entityTypePluralName: string;
    entityTypeName: string;
    hideLabel?: boolean;
    hideRequiredLabel?: boolean;
    normalize: Function;
    type?: string;
}

export class EntityTypeahead extends React.PureComponent<Props> {
    render() {
        const {
            options,
            disabled,
            multiple,
            name,
            validate,
            entityTypePluralName,
            entityTypeName,
            hideLabel,
            hideRequiredLabel,
            normalize,
            type
        } = this.props;

        const testTest = multiple
            ? entityTypePluralName || 'Areas'
            : entityTypeName || 'Area';

        return (
            <Field
                component={RenderDropdown}
                label={
                    hideLabel
                        ? undefined
                        : `${testTest}${
                              validate && !hideRequiredLabel
                                  ? ' (required)'
                                  : ''
                          }`
                }
                name={name}
                options={options}
                placeholder={`Add ${testTest}`}
                validate={validate}
                disabled={disabled}
                fluid
                search
                selection
                multiple={multiple}
                clearable={!disabled}
                closeOnChange
                normalize={normalize}
                type={type}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions,
    entityTypePluralName: makeSelectEntityTypeValue('pluralName'),
    entityTypeName: makeSelectEntityTypeValue('name')
});

export default connect(mapStateToProps)(EntityTypeahead);
